import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import MenuCategorySnapshot from '@square/dashboard-items-data/models/invoices/cart/menu-category-snapshot';
import CategoryMembership from '@square/dashboard-items-data/models/category-membership';
import { Item } from '@square/dashboard-protos/models/squareup/items/items';
import Enum from '@square/dashboard-utilities/utils/enum';

// https://prototype.sqprod.co/#/docs/squareup.api.items.Item#type
export const ItemType = new Enum(Object.keys(Item.Type));

// squareup.api.items.Item
export default ProtoBaseModel.extend({
  id: attr(String),
  description: attr(String),
  name: attr(String),
  taxable: attr(Boolean),
  catalogObjectReference: attr(CatalogObjectReference),
  type: attr(ItemType),
  menuCategory: attr(MenuCategorySnapshot),
  additionalCategories: repeated(CategoryMembership)
}).reopenClass({
  createFor(item) {
    return this.create({
      id: item.id,
      description: item.description,
      name: item.name,
      taxable: item.taxable,
      catalogObjectReference: CatalogObjectReference.fromCatalogModel(item),
      type: item.type,
      menuCategory: item.menuCategory
    });
  }
});